<template>
  <div id="root">
    <div :class="cssClasses" v-resize:debounce="onResize">
      <router-view
        name="layout"
        :is-x-small="screen.isXSmall"
        :is-large="screen.isLarge"
      >
        <div :class="isHomePage ? 'content-vh' : 'content'">
          <router-view name="content" />
          <the-footer v-if="!isLoginForm" />
        </div>
      </router-view>
    </div>
  </div>
</template>

<script>
import ServerEvents from "./services/server-events";
import TheFooter from "./components/the-footer";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";
import resize from 'vue-resize-directive'

function getScreenSizeInfo() {
  const screenSizes = sizes();

  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter(cl => screenSizes[cl])
  };
}

export default {
  name: "app",
  components: {
    TheFooter
  },
  data() {
    return {
      screen: getScreenSizeInfo()
    };
  },
  directives: {
    resize
  },
  computed: {
    cssClasses() {
      return ["app"].concat(this.screen.cssClasses);
    },
    isHomePage() {
      return this.$route.path === '/home';
    },
    isLoginForm() {
      return this.$route.path === '/login-form';
    },
  },
  methods: {
    screenSizeChanged() {
      this.screen = getScreenSizeInfo();
    },
    subscribe() {
      this.serverEvents.sendMessage({ cmd: 'subscribe-dic-events' });
    },
    unsubscribe() {
      this.serverEvents.sendMessage({ cmd: 'unsubscribe-dic-events' });
    },
    onResize(sender) {
      const containerSize = { width : sender.offsetWidth, height : sender.offsetHeight };
      this.$store.commit("setAppContainerSize", containerSize);
    }
  },
  async created() {
    // Open socket
    this.serverEvents = new ServerEvents();
    this.serverEvents.$on('socket-message', (msg) => {
      const invalidateCache = () => {
        // eslint-disable-next-line
        // console.debug('App::invalidateCache');
        this.$store.cache.clear();
      }
      if (msg.notificationType === 'DIC_CHANGED') {
        if (this.cacheTimeout) clearTimeout(this.cacheTimeout);
        this.cacheTimeout = setTimeout(() => invalidateCache(), 100);
      }
    });
    this.serverEvents.$on('socket-open', () => this.subscribe());
    // eslint-disable-next-line no-console
    this.serverEvents.$on('socket-error', err => console.error(err));
    try {
      await this.serverEvents.connect();
    } catch(err) {
      //this.onDataError(err);
    }
  },
  mounted() {
    subscribe(this.screenSizeChanged);
  },

  beforeDestroy() {
    unsubscribe(this.screenSizeChanged);
  }
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  min-height: 100%;
  height: 100%;
}

#root {
  height: 100%;
}

* {
  box-sizing: border-box;
}

.app {
  @import "./themes/generated/variables.base.scss";
  background-color: darken($base-bg, 5);
  display: flex;
  height: 100%;
  width: 100%;
}

.content-vh {
  flex: 1 1 auto;
  min-height: 0;
}

.content {
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
